export const WeekDaysOptions = [
  {
    value: 'Monday',
    content: 'Monday',
  },
  {
    value: 'Tuesday',
    content: 'Tuesday',
  },
  {
    value: 'Wednesday',
    content: 'Wednesday',
  },
  {
    value: 'Thursday',
    content: 'Thursday',
  },
  {
    value: 'Friday',
    content: 'Friday',
  },
  {
    value: 'Saturday',
    content: 'Saturday',
  },
  {
    value: 'Sunday',
    content: 'Sunday',
  },
]

export const RedemptionTypeOptions = [
  {
    value: 0,
    content: 'AUTOMATIC',
  },
  {
    value: 1,
    content: 'COUPON',
  },
]

export const PERIOD = [
  {
    value: 0,
    content: 'Today',
  },
  {
    value: 1,
    content: 'Yesterday',
  },
  {
    value: 2,
    content: 'Last 7 days',
  },
  {
    value: 3,
    content: 'Last 14 days',
  },
  {
    value: 4,
    content: 'Last 30 days',
  },
  {
    value: 5,
    content: 'Last 90 days',
  },
  {
    value: 6,
    content: 'This Quarter',
  },
  {
    value: 7,
    content: 'Last Quarter',
  },
  {
    value: 8,
    content: 'This Year',
  },
  {
    value: 9,
    content: 'Last Year',
  },
]

export enum PlatformType {
  All = '0',
  Bigcommerce = '1',
  Shopify = '2',
}
